export enum EntityTypes {
    CLIENTS = 'clients',
}
